import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import ScriptInjector from '@/components/ScriptInjector';
import Home from '@/pages/Home';
import FindSpace from '@/pages/FindSpace';
import SpaceDetail from '@/pages/SpaceDetail';
import BlogListing from '@/pages/BlogListing';
import BlogDetail from '@/pages/BlogDetail';
import Gallery from '@/pages/Gallery';
import { LocationCards, LocationGallery } from '@/pages/GalleryNew';
import AboutUs from '@/pages/AboutUs';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminSettings from '@/pages/admin/Settings';
import AdminSectionVisibility from '@/pages/admin/SectionVisibility';
import AdminHeaderSettings from '@/pages/admin/HeaderSettings';
import AdminFooterSettings from '@/pages/admin/FooterSettings';
import AdminLocations from '@/pages/admin/Locations';
import AdminWorkspaces from '@/pages/admin/Workspaces';
import AdminAmenities from '@/pages/admin/Amenities';
import AdminTestimonials from '@/pages/admin/Testimonials';
import AdminBlog from '@/pages/admin/Blog';
import AdminGallery from '@/pages/admin/Gallery';
import AdminHeroSlides from '@/pages/admin/HeroSlides';
import AdminCareCards from '@/pages/admin/CareCards';
import AdminGalleryImages from '@/pages/admin/GalleryImages';
import AdminAboutContent from '@/pages/admin/AboutContent';
import AdminMilestones from '@/pages/admin/Milestones';
import AdminAboutPage from '@/pages/admin/AboutPage';
import AdminSalesforceWebhook from '@/pages/admin/SalesforceWebhook';
import AdminSEOSettings from '@/pages/admin/SEOSettings';
import AdminLeadCenter from '@/pages/admin/LeadCenter';
import AdminEmailSettings from '@/pages/admin/EmailSettings';
import AdminContactFormEditor from '@/pages/admin/ContactFormEditor';
import AdminPopupSettings from '@/pages/admin/PopupSettings';
import AdminFindSpacePage from '@/pages/admin/FindSpacePage';
import AdminSocialMediaLinks from '@/pages/admin/SocialMediaLinks';
import AdminFindUsContent from '@/pages/admin/FindUsContent';
import AdminAboutBuloke from '@/pages/admin/AboutBulokeSettings';
import AdminSiteScripts from '@/pages/admin/SiteScripts';
import AdminLibrary from '@/pages/admin/Library';
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <ScriptInjector />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="find-space" element={<FindSpace />} />
            <Route path="space/:id" element={<SpaceDetail />} />
            <Route path="blog" element={<BlogListing />} />
            <Route path="blog/:slug" element={<BlogDetail />} />
            <Route path="gallery" element={<LocationCards />} />
            <Route path="gallery/:slug" element={<LocationGallery />} />
            <Route path="about" element={<AboutUs />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/sections" element={<ProtectedRoute><AdminSectionVisibility /></ProtectedRoute>} />
          <Route path="/admin/header" element={<ProtectedRoute><AdminHeaderSettings /></ProtectedRoute>} />
          <Route path="/admin/footer" element={<ProtectedRoute><AdminFooterSettings /></ProtectedRoute>} />
          <Route path="/admin/hero-slides" element={<ProtectedRoute><AdminHeroSlides /></ProtectedRoute>} />
          <Route path="/admin/locations" element={<ProtectedRoute><AdminLocations /></ProtectedRoute>} />
          <Route path="/admin/spaces" element={<ProtectedRoute><AdminWorkspaces /></ProtectedRoute>} />
          <Route path="/admin/workspaces" element={<ProtectedRoute><AdminWorkspaces /></ProtectedRoute>} />
          <Route path="/admin/amenities" element={<ProtectedRoute><AdminAmenities /></ProtectedRoute>} />
          <Route path="/admin/testimonials" element={<ProtectedRoute><AdminTestimonials /></ProtectedRoute>} />
          <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
          <Route path="/admin/gallery" element={<ProtectedRoute><AdminGallery /></ProtectedRoute>} />
          <Route path="/admin/care-cards" element={<ProtectedRoute><AdminCareCards /></ProtectedRoute>} />
          <Route path="/admin/gallery-carousel" element={<ProtectedRoute><AdminGalleryImages /></ProtectedRoute>} />
          <Route path="/admin/about-content" element={<ProtectedRoute><AdminAboutContent /></ProtectedRoute>} />
          <Route path="/admin/milestones" element={<ProtectedRoute><AdminMilestones /></ProtectedRoute>} />
          <Route path="/admin/about-page" element={<ProtectedRoute><AdminAboutPage /></ProtectedRoute>} />
          <Route path="/admin/seo" element={<ProtectedRoute><AdminSEOSettings /></ProtectedRoute>} />
          <Route path="/admin/leads" element={<ProtectedRoute><AdminLeadCenter /></ProtectedRoute>} />
          <Route path="/admin/email-settings" element={<ProtectedRoute><AdminEmailSettings /></ProtectedRoute>} />
          <Route path="/admin/contact-form" element={<ProtectedRoute><AdminContactFormEditor /></ProtectedRoute>} />
          <Route path="/admin/popup-settings" element={<ProtectedRoute><AdminPopupSettings /></ProtectedRoute>} />
          <Route path="/admin/find-space-page" element={<ProtectedRoute><AdminFindSpacePage /></ProtectedRoute>} />
          <Route path="/admin/social-media" element={<ProtectedRoute><AdminSocialMediaLinks /></ProtectedRoute>} />
          <Route path="/admin/find-us" element={<ProtectedRoute><AdminFindUsContent /></ProtectedRoute>} />
          <Route path="/admin/site-scripts" element={<ProtectedRoute><AdminSiteScripts /></ProtectedRoute>} />
          <Route path="/admin/salesforce-webhook" element={<ProtectedRoute><AdminSalesforceWebhook /></ProtectedRoute>} />
          <Route path="/admin/library" element={<ProtectedRoute><AdminLibrary /></ProtectedRoute>} />
          <Route path="/admin/about-buloke" element={<ProtectedRoute><AdminAboutBuloke /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;